import React from 'react';
import styled from 'styled-components/macro';
import { isPortrait, widthEm } from '../../utils/size';
import { copyFor } from '../../copy/copy';

export const NotYourRepInfo = styled.div`
    font-family: Lato;
    color: #333;
    font-size: 10px;
    line-height: 1.33;
    font-weight: bold;
    margin-top: 5px;
    ${() =>
        isPortrait() && widthEm() > 28 &&
        `display: flex;
        flex-direction: column;
        a {
          padding-top: 5px;
        }
    `};
    ${props => (props.isLocalRepLoading ? `display: none;` : '')};
`;
export const NotYourRepContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    left: 15px;
    bottom: 12px;
    z-index: 2;
`;

export const FindRepLink = styled.a`
    color: #008eff;
    font-weight: normal;
    cursor: pointer;
`;

const ChangeCountryContainer = styled.div`
    margin-top: 6px;
    font-size: 12px;
    line-height: 16px;
    span {
        color: #008eff;
        cursor: pointer;
    }
`;

export const CountryContainer = props =>
    <ChangeCountryContainer>
        {copyFor('global','liveInUSUK')}
        <span onClick={props.onClick}>
            {copyFor('global','findLegislators')}
        </span>
    </ChangeCountryContainer>
